import { Badge, Tooltip, Text } from "@mantine/core"
import {
  IconAlertTriangle,
  IconChecks,
  IconDatabase,
  IconFileCheck,
  IconHourglass,
} from "@tabler/icons-react"

import { FindIngestionsResponseDtoStatus } from "~/gen/api"
import { isIngestionStatusType } from "~/pages/Admin/Ingestion/ProductImport/IngestionListWrapper"

export const IngestionStatusColorEnum: {
  [key in FindIngestionsResponseDtoStatus]: string
} = {
  BLANK_PRODUCTS_VERIFIED: "var(--mantine-color-orange-6)",
  PRODUCTS_VERIFIED: "var(--mantine-color-orange-6)",
  PENDING: "var(--mantine-color-yellow-5)",
  PRODUCTS_INGESTED: "var(--mantine-color-purple-9)",
  PROCESSED: "var(--mantine-color-green-6)",
  ERROR: "var(--mantine-color-error)",
  BLANK_PRODUCTS_INGESTED: "var(--mantine-color-gray-6)",
  FAILED: "var(--mantine-color-error)",
}

export function getIngestionStatusColor(
  status: FindIngestionsResponseDtoStatus
): string {
  if (isIngestionStatusType(status)) {
    return IngestionStatusColorEnum[status]
  }
  return "var(--mantine-color-gray-6)"
}

function getIngestionBadgeIcon(status: FindIngestionsResponseDtoStatus) {
  switch (status) {
    case "PENDING":
      return <IconHourglass />
    case "PRODUCTS_INGESTED":
      return <IconDatabase />
    case "BLANK_PRODUCTS_INGESTED":
      return <IconDatabase />
    case "PROCESSED":
      return <IconChecks />
    case "ERROR":
      return <IconAlertTriangle />
    case "PRODUCTS_VERIFIED":
      return <IconFileCheck />
    case "FAILED":
      return <IconAlertTriangle />
    default:
      return
  }
}

export function IngestionStatusBadge({
  status,
}: {
  status: FindIngestionsResponseDtoStatus
}) {
  const color = getIngestionStatusColor(status)
  const icon = getIngestionBadgeIcon(status)

  return (
    <Tooltip label={status}>
      <Badge size="lg" leftSection={icon} color={color} autoContrast>
        <Text fw="bold">{status}</Text>
      </Badge>
    </Tooltip>
  )
}
